import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { Orderlist } from "../../../controllers/V1/products/productController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
import {list as generalData} from "../../../controllers/V1/cms/generalDataController";
import moment from "moment";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('21:31:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('21:30:00');

  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      const today = new Date();
      let from_date = formData.get('from_date');
      let to_date = formData.get('to_date');

      if(from_date && !to_date){
        to_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      }

      const option = {
        isExport : true,
        condition: {
          ...(formData.get("order_no") && { order_no: formData.get("order_no") } ),

          ...(formData.get("buyer_first_name") && { buyer_first_name: { $regex: formData.get("buyer_first_name"), $options: "i" } } ),
          ...(formData.get("buyer_last_name") && { buyer_last_name: { $regex: formData.get("buyer_last_name"), $options: "i" } } ),
          ...(formData.get("buyer_mobile") && { buyer_mobile: parseInt(formData.get("buyer_mobile")) } ),

          ...(formData.get("seller_first_name") && { buyer_first_name: { $regex: formData.get("seller_first_name"), $options: "i" } } ),
          ...(formData.get("seller_last_name") && { buyer_first_name: { $regex: formData.get("seller_last_name"), $options: "i" } } ),
          ...(formData.get("seller_mobile") && { seller_mobile: parseInt(formData.get("seller_mobile")) } ),
          ...(formData.get("seller_pos_number") && { seller_pos_number: parseInt(formData.get("seller_pos_number")) } ),

          ...(formData.get("product_name") && { product_name: { $regex: formData.get("product_name"), $options: "i" } } ),

          ...(formData.get("voucher_number") && { voucher_number: parseInt(formData.get("voucher_number")) } ),
          ...(formData.get("qty") && { qty: parseInt(formData.get("qty")) } ),
          ...(formData.get("rate") && { qty: parseInt(formData.get("rate")) } ),
          ...(formData.get("points") && { qty: parseInt(formData.get("points")) } ),

          ...(formData.get("status") && { status: { $regex: formData.get("status"), $options: "i" } } ),

          createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`, $lte : `${todayDate} ${todayTime}`}
        },
        select: {
          ...(formData.get("select_order_no")           && { order_no : true } ),

          ...(formData.get("select_buyer_first_name")   && { buyer_first_name : true } ),
          ...(formData.get("select_buyer_last_name")    && { buyer_last_name : true } ),
          ...(formData.get("select_buyer_mobile")       && { buyer_mobile : true } ),

          ...(formData.get("select_seller_first_name")  && { seller_first_name : true } ),
          ...(formData.get("select_seller_last_name")   && { seller_last_name : true } ),
          ...(formData.get("select_seller_mobile")      && { seller_mobile: true } ),
          ...(formData.get("select_seller_pos_number")  && { seller_pos_number: true } ),

          ...(formData.get("select_voucher_number")     && { voucher_number: true } ),
          ...(formData.get("select_product_name")       && { product_name : true } ),
          ...(formData.get("select_unit")               && { unit : true } ),
          ...(formData.get("select_rate")               && { rate: true } ),
          ...(formData.get("select_qty")                && { qty: true } ),
          ...(formData.get("select_total")              && { total : true } ),
          ...(formData.get("select_discount")           && { discount : true } ),
          ...(formData.get("select_total_point")        && { total_point : true } ),
          ...(formData.get("select_status")             && { status: true } ),
          ...(formData.get("select_delivery_address")   && { isDelivery : true, delivery_address: true, pickupAddress : true } ),
          ...(formData.get("select_delivery_status")    && { deliveryStatus : true } ),
          ...(formData.get("select_createdAt")          && { createdAt: true } )
        },
        sort : {_id : -1}
      };

      // Make the API call
      const res = await Orderlist(option);
      if (res.status === true) {
        if(res?.result?.length > 0){
          const exportData = await prepareExportData(res.result, option.select);
          
          await exportToExcel(exportData); 
        }
        handleCancel(); 
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const prepareExportData = async (listData=[], select={}) => {
    const {buyer_first_name, buyer_last_name, buyer_mobile, createdAt, order_no, product_name, unit, qty, rate, total, discount, total_point, seller_first_name, seller_last_name, seller_mobile, seller_pos_number, isDelivery, delivery_address, pickupAddress, voucher_number, status, deliveryStatus}=select;
    if(listData.length > 0){
      const result = Promise.all((listData.map((items)=>{
        return{
          ...((
              order_no || 
              buyer_first_name ||
              buyer_last_name || 
              buyer_mobile || 
              product_name || 
              qty || 
              rate || 
              seller_first_name || 
              seller_last_name || 
              seller_mobile || 
              seller_pos_number ||
              total_point || 
              voucher_number ||
              isDelivery ||
              delivery_address ||
              deliveryStatus ||
              discount ||
              createdAt ||
              status 
            ) ? {
                ...(order_no && {"Order No."         : items?.order_no}),
                ...(buyer_first_name && {"Buyer first name"  : items?.buyer_first_name}),
                ...(buyer_last_name && {"Buyer last name"   : items?.buyer_last_name}),
                ...(buyer_mobile && {"Buyer mobile"      : items?.buyer_mobile}),
                ...(seller_first_name && {"Seller first name" : items?.seller_first_name}),
                ...(seller_last_name && {"Seller last name"  : items?.seller_last_name}),
                ...(seller_mobile && {"Seller mobile"     : items?.seller_mobile}),
                ...(seller_pos_number && {"POS number"        : items?.seller_pos_number}),
                ...(voucher_number && {"Voucher Number"    : items?.voucher_number}),
                ...(product_name && {"Product name"      : items?.product_name}),
                ...(unit && {"Unit"              : items?.variant_id?.unit}),
                ...(rate && {"Rate"              : items?.rate}),
                ...(qty && {"Qty"               : items?.qty}),
                ...(total && {"Total"             : items?.qty * items?.rate}),
                ...(discount && {"Discount"          : items?.discount}),
                ...(total_point && {"Sub Total"         : items?.total_point}),
                ...(status && {"Status"        : items?.status}),
                ...(deliveryStatus && {"Delivery Status"   : items?.deliveryStatus || "Pending"}),
                ...(isDelivery  && {"Delivery/Pickup Address"        : (items?.delivery_address && Object.keys(items?.delivery_address).length > 0) ? `${items?.delivery_address?.flat_no}, ${items?.delivery_address?.building}, ${items?.delivery_address?.street}, ${items?.delivery_address?.city}, ${items?.delivery_address?.postalCode}` : `${items?.pickupAddress?.name}, (${items?.pickupAddress?.mobile}), ${items?.pickupAddress?.address}` }),
                ...(createdAt && {"Order Date"        : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY HH:mm')})
              } : {
                "Order No."         : items?.order_no,
                "Buyer first name"  : items?.buyer_first_name,
                "Buyer last name"   : items?.buyer_last_name,
                "Buyer mobile"      : items?.buyer_mobile,
                "Seller first name" : items?.seller_first_name,
                "Seller last name"  : items?.seller_last_name,
                "Seller mobile"     : items?.seller_mobile,
                "POS number"        : items?.seller_pos_number,
                "Voucher Number"    : items?.voucher_number,
                "Product name"      : items?.product_name,
                "Unit"              : items?.variant_id?.unit,
                "Rate"              : items?.rate,
                "Qty"               : items?.qty,
                "Total"             : items?.qty * items?.rate,
                "Discount"          : items?.discount,
                "Sub Total"         : items?.total_point,
                "Status"            : items?.status,
                "Delivery Status"   : items?.deliveryStatus || "Pending",
                "Delivery/Pickup Address"  : items?.isDelivery === 'Y' ? (`${items?.delivery_address?.flat_no}, ${items?.delivery_address?.building}, ${items?.delivery_address?.street}, ${items?.delivery_address?.city}, ${items?.delivery_address?.postalCode}`):(`${items?.pickupAddress?.name}, (${items?.pickupAddress?.mobile}), ${items?.pickupAddress?.address}`),
                "Order Date"        : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY h:mm A')
              }
            )
        }
      })));
      return result;
    }else{
      return [];
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Product Orders");
      XLSX.writeFile(workbook, `Product-Orders_${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
    try {
      const option ={}
      const res = await generalData(option);
      if(res?.status === true){
        const time = moment().endOf('day').format('HH:mm');
        const startTime = res?.result?.export_start_time;
        const endTime = res?.result?.export_end_time;
        setTodayTime(endTime || time);
        setYesterdayTime(startTime || time);
      }
    } catch (error) {
      
    }
  }

  useEffect(()=>{
    getGeneralData();
  },[])

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export Order
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="order_no" className="all_lable_for_vendor_dashbaord">Order No. :</label>
                    <input type="text" name="order_no" id="order_no" placeholder="Order No" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="product_name" className="all_lable_for_vendor_dashbaord">Product name :</label>
                    <input type="text" name="product_name" id="product_name" placeholder="Product name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="qty" className="all_lable_for_vendor_dashbaord">Qty :</label>
                    <input type="number" name="qty" id="qty" placeholder="Qty" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="rate" className="all_lable_for_vendor_dashbaord">Rate :</label>
                    <input type="number" name="rate" id="rate" placeholder="Rate" className="form-control categories_select_tg_enter_product" />
                  </div>
                  
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_first_name" className="all_lable_for_vendor_dashbaord">Seller's first name :</label>
                    <input type="text" name="seller_first_name" id="seller_first_name" className="form-control categories_select_tg_enter_product" placeholder="Seller's first name" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_last_name" className="all_lable_for_vendor_dashbaord">Seller's last name :</label>
                    <input type="text" name="seller_last_name" id="seller_last_name" className="form-control categories_select_tg_enter_product" placeholder="Seller's last name" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_mobile" className="all_lable_for_vendor_dashbaord">Seller's mobile :</label>
                    <input type="number" name="seller_mobile" id="seller_mobile" className="form-control categories_select_tg_enter_product" placeholder="Seller's mobile" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_pos_number" className="all_lable_for_vendor_dashbaord">Seller's POS No. :</label>
                    <input type="number" name="seller_pos_number" id="seller_pos_number" className="form-control categories_select_tg_enter_product" placeholder="Seller's POS number" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_first_name" className="all_lable_for_vendor_dashbaord">Buyer's first name :</label>
                    <input type="text" name="buyer_first_name" id="buyer_first_name" className="form-control categories_select_tg_enter_product" placeholder="Buyer first name" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_last_name" className="all_lable_for_vendor_dashbaord">Buyer's last name :</label>
                    <input type="text" name="buyer_last_name" id="buyer_last_name" className="form-control categories_select_tg_enter_product" placeholder="Buyer's last name" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_mobile" className="all_lable_for_vendor_dashbaord">Buyer's mobile :</label>
                    <input type="number" name="buyer_mobile" id="buyer_mobile" className="form-control categories_select_tg_enter_product" placeholder="Buyer's mobile" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="status" className="all_lable_for_vendor_dashbaord">Status :</label>
                    <input type="text" name="status" id="status" className="form-control categories_select_tg_enter_product" placeholder="Status" />
                  </div>
                  
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Date specific (If any) : </label>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      From :
                    </label>
                    <input
                      type="date"
                      name="valid_date"
                      id="valid_date"
                      value={yesterdayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="valid_time"
                      id="valid_time"
                      value={yesterdayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      To :
                    </label>
                    <input
                      type="date"
                      name="expire_date"
                      id="expire_date"
                      value={todayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="expire_time"
                      id="expire_time"
                      value={todayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  

                  {/* Selection Checkboxes for Export */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                  </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_order_no" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_order_no" id="select_order_no" className="form-check-input" /> Order No.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_first_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_first_name" id="select_buyer_first_name" className="form-check-input" /> Buyer's first name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_last_name" id="select_buyer_last_name" className="form-check-input" /> Buyer's last name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_mobile" id="select_buyer_mobile" className="form-check-input" /> Buyer's mobile
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_first_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_first_name" id="select_seller_first_name" className="form-check-input" /> Seller's first name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_last_name" id="select_seller_last_name" className="form-check-input" /> Seller's last name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_mobile" id="select_seller_mobile" className="form-check-input" /> Seller's mobile
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_pos_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_pos_number" id="select_seller_pos_number" className="form-check-input" /> Seller's POS number
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_product_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_product_name" id="select_product_name" className="form-check-input" /> Product Name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_unit" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_unit" id="select_unit" className="form-check-input" /> Unit
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_rate" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_rate" id="select_rate" className="form-check-input" /> Rate
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_qty" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_qty" id="select_qty" className="form-check-input" /> Qty
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_total" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_total" id="select_total" className="form-check-input" /> Total
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_discount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_discount" id="select_discount" className="form-check-input" /> Discount
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_total_point" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_total_point" id="select_total_point" className="form-check-input" /> 
                        Total Point
                      </label>
                    </div>
                    
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_delivery_address" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_delivery_address" id="select_delivery_address" className="form-check-input" /> Delivery Address.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_voucher_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_voucher_number" id="select_voucher_number" className="form-check-input" /> Voucher No.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_createdAt" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_createdAt" id="select_createdAt" className="form-check-input" /> Order Date
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_status" id="select_status" className="form-check-input" /> Status
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_delivery_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_delivery_status" id="select_delivery_status" className="form-check-input" /> Delivery Status
                      </label>
                    </div>
          
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
